(function(){
  // Scope to collection pages only
  var scope = document.querySelector('.template-collection');
  if (!scope) return;

  var PREFIX = 'shopify-section-template--21561619644656';

  // Use main#main if present; fallback to scope itself
  var container = scope.querySelector('main#main') || scope;

  // Only sections with matching id prefix
  var sections = container.querySelectorAll(':scope > .shopify-section[id^="' + PREFIX + '"]');
  if (!sections.length) return;

  sections.forEach(function(el, idx){
    var n = idx + 1;

    el.classList.add('mfw-reveal');

    if (n === 1) {
      el.classList.add('mfw-reveal--bottom');
    } else if (n === 2) {
      el.classList.add('mfw-reveal--left');
    } else if (n === 3) {
      el.classList.add('mfw-reveal--right');
    } else {
      if (n % 2 === 0) el.classList.add('mfw-reveal--left');
      else el.classList.add('mfw-reveal--right');
    }
  });

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.12,
    rootMargin: "0px 0px -10% 0px"
  });

  sections.forEach(function(el){ io.observe(el); });
})();

document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.js-mwf-variant-toggle');
  if (!toggle) return;

  const card = toggle.closest('.product-item');
  if (!card) return;

  const dropdown = card.querySelector('.mwf-variant-dropdown');
  if (!dropdown) return;

  const isHidden = dropdown.hasAttribute('hidden');

  // Toggle hidden (compatible)
  if (isHidden) dropdown.removeAttribute('hidden');
  else dropdown.setAttribute('hidden', '');

  // aria-expanded should reflect the NEW state (open => true)
  toggle.setAttribute('aria-expanded', String(isHidden));

  // When opening, set hidden input "id" to selected variant
  if (isHidden) {
    const select = dropdown.querySelector('.mwf-variant-select');
    const hiddenId = card.querySelector('form input[name="id"]');
    if (select && hiddenId) hiddenId.value = select.value;
  }
});

document.addEventListener('change', function (e) {
  const select = e.target.closest('.mwf-variant-select');
  if (!select) return;

  const card = select.closest('.product-item');
  if (!card) return;

  const hiddenId = card.querySelector('form input[name="id"]');
  if (hiddenId) hiddenId.value = select.value;
});

(function forceScopedLinksNewTab(){
  const PREFIX = "shopify-section-template--21561619644656";
  const selector = `[id^="${PREFIX}"] a[href]`;

  function apply() {
    document.querySelectorAll(selector).forEach(a => {
      const href = a.getAttribute("href");
      if (!href) return;

      // Skip anchors and special protocols
      if (
        href.startsWith("#") ||
        href.startsWith("javascript:") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:")
      ) return;

      a.target = "_blank";
      a.rel = "noopener noreferrer";
    });
  }

  apply();

  // For dynamically injected content
  const mo = new MutationObserver(apply);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
